import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";
import Utility from "../../common/Utility";
import Cookies from "js-cookie";

class SubscribeComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.body = document.querySelector('body');
        this.ctaModal = this.body.querySelectorAll('.subscribeCta a');
        this.modal = new GenericModalComponent(this.element);
        this.showModalParameter = Utility.getUrlParameter('acceptRegulation');
        this.urlBack = Utility.getUrlParameter('urlBack');
        this.campaignCode = '';
        this.endpoint = `/api/1.0/loyalty/campaign/dlover2025/subscribe`;
        this.modalAlreadySeen = Cookies.get('yxp_regulation_modal_visibility');
        this.acceptButton = this.element.querySelector('.primary-button');
        this.refuseButton = this.element.querySelector('.secondary-button');
        this.closeButton = this.element.querySelector('.generic-modal__close');
        this.isSubcribed = this.element.dataset.subscribed;

        this.init();
    }

    acceptRegulamentationListener() {
        if (this.ctaModal) {
            this.ctaModal.forEach((el) => {
                el.addEventListener('click', () => {
                    this.checkModalVisibility();
                })
            })
        }
    }

    checkModalVisibility() {
        if (this.isSubcribed === 'true') return;
        if (this.showModalParameter) this.startModal();
        else if (!this.modalAlreadySeen) this.startModal();
    }


    startModal() {
        this.modal.openModal();
        if (this.showModalParameter) window.history.replaceState(null, '', window.location.pathname || '/');

    }

    subscribeCampaign() {
        this.element.classList.add('loading');
        youserxp.ajax(this.endpoint, {
            method: 'POST',
            auth: true,
        }, {}, "json").then(() => {
            this.modal.closeModal();
            Cookies.set('yxp_regulation_modal_visibility', true);
            this.urlBack ? window.location.href = this.urlBack : window.location.reload();
        }, () => {
            this.element.classList.remove('loading');
        });
    }


    hideModal() {
        this.modal.closeModal();
    }

    init() {
        if (this.showModalParameter) this.startModal();

        this.acceptButton.addEventListener('click', () => this.subscribeCampaign());
        this.refuseButton.addEventListener('click', () => this.hideModal());
        this.closeButton.addEventListener('click', () => this.hideModal());

        this.acceptRegulamentationListener();

    }

}

export default SubscribeComponent;